import styled from "styled-components";
import { getMemberbyId } from "../../../context/members/membercontext";
import { device } from "../../../style/styled-components/helpers/device";
import NameCard from "./NameCard";
import ConsultRequest from "./ConsultRequest";
const ContactPoints = ({ members, consultLabel, noConsult }) => {
  return (
    <Wrap>
      <Div length={members?.length}>
        {members?.map((x, idx) => {
          return <NameCard key={idx} member={getMemberbyId(x)} unmaskContact />;
        })}
      </Div>
      {!noConsult && <ConsultRequest members={members?.map((x) => getMemberbyId(x))} label={consultLabel} />}
    </Wrap>
  );
};
export default ContactPoints;
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Div = styled.div`
  width: 100%;
  display: grid;
  justify-content: center;
  gap: 1.5rem;
  grid-template-columns: minmax(0, 30rem);
  @media ${device.laptop} {
    // 둘 이상일 때만 column 두개
    grid-template-columns: ${({ length }) =>
      length && length > 1 ? "repeat(2, minmax(0, 30rem))" : "minmax(0, 30rem)"};
  }
`;
